import { cn } from "@/lib/utils";
import { CheckCircle, WarningCircle, Info, HandHeart, X } from "@phosphor-icons/react";

const VARIANTS = {
  success: { icon: CheckCircle, wrap: "bg-teal/12 border-teal/30", iconCls: "bg-teal text-teal-foreground", title: "text-teal-ink" },
  warning: { icon: WarningCircle, wrap: "bg-warning/12 border-warning/30", iconCls: "bg-warning text-white", title: "text-warning-ink" },
  error: { icon: Info, wrap: "bg-destructive/10 border-destructive/25", iconCls: "bg-destructive text-destructive-foreground", title: "text-destructive-ink" },
  encouragement: { icon: HandHeart, wrap: "bg-primary/10 border-primary/25", iconCls: "bg-primary text-primary-foreground", title: "text-primary-strong" },
};

export function FeedbackMessage({ variant = "success", title, message, onDismiss }) {
  const v = VARIANTS[variant];
  return (
    <div className={cn("flex items-start gap-3 rounded-3xl border-2 p-4", v.wrap)} role="status">
      <span className={cn("flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl", v.iconCls)}>
        <v.icon size={22} weight="fill" />
      </span>
      <div className="flex-1 pt-0.5">
        <p className={cn("font-display text-base font-extrabold", v.title)}>{title}</p>
        {message && <p className="text-sm font-medium leading-relaxed text-muted-foreground">{message}</p>}
      </div>
      {onDismiss && (
        <button onClick={onDismiss} aria-label="Dismiss" className="rounded-full p-1.5 text-muted-foreground hover:bg-foreground/10">
          <X size={16} weight="bold" />
        </button>
      )}
    </div>
  );
}
